import { render, staticRenderFns } from "./SelectItemListWizardOld.vue?vue&type=template&id=4bb67eb6"
import script from "./SelectItemListWizardOld.vue?vue&type=script&lang=js"
export * from "./SelectItemListWizardOld.vue?vue&type=script&lang=js"
import style0 from "./SelectItemListWizardOld.vue?vue&type=style&index=0&id=4bb67eb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports